import React from "react";

const Tender = () => {
  return (
    <div>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4520_10682)">
          <path
            opacity="0.48"
            d="M48 0H24C10.7452 0 0 10.7452 0 24V48C0 61.2548 10.7452 72 24 72H48C61.2548 72 72 61.2548 72 48V24C72 10.7452 61.2548 0 48 0Z"
            fill="#54FDA3"
          />
          <g filter="url(#filter0_d_4520_10682)">
            <path
              d="M36 60C49.2548 60 60 49.2548 60 36C60 22.7452 49.2548 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2548 22.7452 60 36 60Z"
              fill="white"
            />
          </g>
          <path
            d="M36.8457 46H36V41.583H36.5703C36.8062 41.583 37.0385 41.6416 37.2461 41.7537C37.4537 41.8657 37.6304 42.0279 37.7598 42.2251C37.8909 42.4214 37.9704 42.6471 37.9922 42.8821C38.014 43.1171 37.9775 43.354 37.8848 43.571L36.8457 46ZM38.002 41.0491C37.5878 40.7438 37.0868 40.5797 36.5723 40.5811H36.002V37.928C34.3464 37.6876 32.831 36.863 31.7305 35.603C30.6152 34.3289 30.0007 32.6933 30 31C30.0019 29.1441 30.7404 27.3646 32.0527 26.0522C33.3651 24.7399 35.1441 24.0019 37 24C38.8559 24.0019 40.6349 24.7399 41.9473 26.0522C43.2596 27.3646 43.9981 29.1441 44 31C44.0005 32.6938 43.3866 34.3301 42.2715 35.605C41.172 36.8658 39.6576 37.6906 38.002 37.9299V41.052V41.0491Z"
            fill="#292929"
          />
          <path
            d="M36.573 41.582H33.55L34.02 39.315C34.0469 39.1854 34.0415 39.0512 34.0042 38.9242C33.9668 38.7972 33.8988 38.6814 33.806 38.587C33.7323 38.5124 33.6446 38.4532 33.5479 38.4128C33.4511 38.3724 33.3473 38.3516 33.2425 38.3516C33.1377 38.3516 33.0339 38.3724 32.9371 38.4128C32.8404 38.4532 32.7527 38.5124 32.679 38.587L29.828 41.439C29.6919 41.5687 29.5837 41.7248 29.5101 41.8978C29.4365 42.0708 29.3991 42.257 29.4 42.445V46.573C29.4011 46.9509 29.5516 47.313 29.8188 47.5802C30.086 47.8474 30.4481 47.998 30.826 47.999H35.047C35.3259 47.9981 35.5984 47.916 35.8314 47.7628C36.0644 47.6095 36.2477 47.3917 36.359 47.136L37.885 43.571C37.9769 43.3539 38.0138 43.1174 37.9923 42.8826C37.9708 42.6478 37.8916 42.4219 37.7618 42.2251C37.632 42.0282 37.4555 41.8665 37.2481 41.7544C37.0407 41.6422 36.8088 41.583 36.573 41.582Z"
            fill="#292929"
          />
          <mask
            id="mask0_4520_10682"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="28"
            width="10"
            height="6"
          >
            <path d="M42 28.3242H32V33.8882H42V28.3242Z" fill="white" />
          </mask>
          <g mask="url(#mask0_4520_10682)">
            <path
              d="M32 33.8841V28.3421C32.052 28.3421 32.105 28.3321 32.158 28.3321C32.639 28.3321 33.12 28.3321 33.602 28.3321C33.9286 28.3159 34.2523 28.399 34.5307 28.5706C34.809 28.7421 35.0288 28.9941 35.161 29.2931C35.2988 29.5644 35.355 29.8698 35.3228 30.1724C35.2907 30.4749 35.1716 30.7617 34.98 30.9981C34.9652 31.0125 34.9534 31.0298 34.9454 31.0488C34.9373 31.0679 34.9332 31.0884 34.9332 31.1091C34.9332 31.1298 34.9373 31.1502 34.9454 31.1693C34.9534 31.1884 34.9652 31.2056 34.98 31.2201C35.1708 31.4578 35.2887 31.7457 35.3194 32.049C35.3501 32.3522 35.2923 32.6579 35.153 32.9291C35.0228 33.2221 34.8079 33.4695 34.536 33.6393C34.264 33.8092 33.9474 33.8937 33.627 33.8821C33.09 33.8901 32.554 33.8821 31.996 33.8821M33.113 29.4421V30.5521C33.303 30.5521 33.481 30.5591 33.658 30.5521C33.8046 30.5492 33.9444 30.4894 34.0476 30.3852C34.1509 30.281 34.2095 30.1407 34.211 29.9941C34.2076 29.8472 34.1472 29.7074 34.0424 29.6043C33.9377 29.5013 33.7969 29.4431 33.65 29.4421C33.478 29.4351 33.304 29.4421 33.113 29.4421ZM33.114 32.7731C33.321 32.7731 33.507 32.7841 33.691 32.7731C33.8278 32.7639 33.9564 32.7047 34.0523 32.6067C34.1482 32.5088 34.2047 32.379 34.211 32.2421C34.218 32.1111 34.1767 31.9821 34.0948 31.8796C34.013 31.7771 33.8963 31.7082 33.767 31.6861C33.5484 31.6689 33.3289 31.6669 33.11 31.6801L33.114 32.7731Z"
              fill="white"
            />
            <path
              d="M38.673 28.3337C39.273 28.3337 39.86 28.3087 40.444 28.3397C40.8558 28.3622 41.2438 28.5396 41.53 28.8364C41.8163 29.1333 41.9795 29.5275 41.987 29.9397C42.005 30.7171 42.005 31.4947 41.987 32.2727C41.9795 32.6849 41.8164 33.0789 41.5304 33.3757C41.2443 33.6725 40.8566 33.8501 40.445 33.8727C39.861 33.9037 39.274 33.8787 38.674 33.8787L38.673 28.3337ZM39.778 32.7717C39.978 32.7717 40.161 32.7817 40.345 32.7717C40.4864 32.7694 40.6213 32.7118 40.7207 32.6112C40.8201 32.5107 40.8762 32.3752 40.877 32.2337C40.8877 31.4811 40.8877 30.7281 40.877 29.9747C40.8757 29.8402 40.8234 29.7111 40.7305 29.6136C40.6377 29.5162 40.5114 29.4576 40.377 29.4497C40.183 29.4327 39.986 29.4497 39.782 29.4497L39.778 32.7717Z"
              fill="white"
            />
            <path
              d="M37.535 28.3438H36.446V33.8758H37.535V28.3438Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_4520_10682"
            x="6"
            y="9"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4520_10682"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4520_10682"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_4520_10682">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Tender;
